/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanClubTextPostNotificationAction } from './FanClubTextPostNotificationAction';
import {
    FanClubTextPostNotificationActionFromJSON,
    FanClubTextPostNotificationActionFromJSONTyped,
    FanClubTextPostNotificationActionToJSON,
} from './FanClubTextPostNotificationAction';

/**
 * 
 * @export
 * @interface FanClubTextPostNotification
 */
export interface FanClubTextPostNotification {
    /**
     * 
     * @type {string}
     * @memberof FanClubTextPostNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FanClubTextPostNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FanClubTextPostNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof FanClubTextPostNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<FanClubTextPostNotificationAction>}
     * @memberof FanClubTextPostNotification
     */
    actions: Array<FanClubTextPostNotificationAction>;
}

/**
 * Check if a given object implements the FanClubTextPostNotification interface.
 */
export function instanceOfFanClubTextPostNotification(value: object): value is FanClubTextPostNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function FanClubTextPostNotificationFromJSON(json: any): FanClubTextPostNotification {
    return FanClubTextPostNotificationFromJSONTyped(json, false);
}

export function FanClubTextPostNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanClubTextPostNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(FanClubTextPostNotificationActionFromJSON)),
    };
}

export function FanClubTextPostNotificationToJSON(value?: FanClubTextPostNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(FanClubTextPostNotificationActionToJSON)),
    };
}

